module.exports = __webpack_public_path__ + "static/assets/cc7da3f731df277b7281d4f3f43420d9.png";